(function ($) {
  $(document).ready(() => {
    /** ======================= TABS ================================= */
    $("[data-entity-tab-btn]").click(function () {
      const tabId = $(this).attr("data-entity-tab-btn");
      $("[data-entity-tab-btn]").removeClass("active");
      $(this).addClass("active");

      $("[data-entity-tab]").addClass("hidden");
      $(`[data-entity-tab="${tabId}"]`).removeClass("hidden");
    });

    /** ======================= THEME CONTENT ================================= */

    $("[data-theme-id] [data-toggle-group-btn]").click(function () {
      const themeId = $(this).closest("[data-theme-id]").attr("data-theme-id");
      $(this).closest("[data-theme-id]").toggleClass("open");

      $(`[data-theme-content-id="${themeId}"]`).slideToggle(200);
    });

    /** ====================== EVIDENCE TABS ================================== */

    $("[data-entity-evidence-btn]").click(function () {
      const datasource = $(this).attr("data-entity-evidence-btn");
      const currentThemeQuestion = datasource?.split("_")[0];

      for (const i of [1, 2, 3, 4, 5]) {
        $(
          `[data-entity-evidence-btn="${currentThemeQuestion}_d${i}"]`,
        ).removeClass("active");
      }
      $(this).addClass("active");

      for (const i of [1, 2, 3, 4, 5]) {
        $(
          `[data-entity-evidence-tab="${currentThemeQuestion}_d${i}"]`,
        ).removeClass("active");
      }
      $(`[data-entity-evidence-tab="${datasource}"]`).addClass("active");
    });
  });
})(jQuery);
